const forgotPasswordES = {
	title: "¿Olvidaste tu contraseña?",
	subtitle: "No te preocupes, le pasa a cualquiera. Ingresa tu correo y te enviamos un enlace para restablecerla.",
	email: "Correo electrónico",
	hint: "Usa el correo con el que te registraste. El enlace expira en 15 minutos.",
	backToSignIn: "Volver a iniciar sesión",
	send: "Enviar enlace",
	sending: "Enviando...",
	success: "¡Listo! Revisa tu bandeja de entrada — te enviamos un enlace para restablecer tu contraseña.",
	toast: {
		error: "No pudimos enviar el correo. Inténtalo de nuevo en un momento.",
	},
};

export default forgotPasswordES;
